






































































































































import { Vue, Component } from 'vue-property-decorator';
import { saveinfo, getHighSch, checkIsFirst } from '../api';
import { isWeiXin } from '@/common/ts/common';
import { Popup, Picker, Toast } from 'vant';
import FormSearchInput from '../components/FormSearchInput.vue';
import PickerInput from '../components/PickerInputold.vue';
import qs from 'qs';

Vue.use(Popup).use(Picker).use(Toast);

@Component({
  components: {
    PickerInput,
    FormSearchInput,
    getHighSch,
  },
})
export default class Active extends Vue {
  unionid: string | null = '';
  phone: string = '';
  name: string = '';
  realname: string = '';
  realcity: string = '';
  dreamsch: string = '';
  qqnum: string = '';
  nowx: boolean = false;
  errinfo: string = '';
  qrinfo: any = {};
  options: any = ['重庆', '非重庆'];
  selectObj: string = '';
  inputStr: string = '';
  islocal: boolean = true;
  isnew: boolean = false;
  isclick: boolean = true;
  mounted() {
    const unionId = window.localStorage.getItem('unionid');
    if (!isWeiXin()) {
      this.errinfo = '请在微信中打开，参与活动';
      this.nowx = true;
      this.$router.push('home');
    } else if (!unionId && isWeiXin()) {
      this.WechatLogin();
      return false;
    }
    this.checkExist(unionId);
  }
  async getHighSch(inStr: string) {
    return await getHighSch(inStr);
  }
  selectData(e: any) {
    this.inputStr = e;
  }
  selectData1(e: any) {
    if (e + '' === '重庆') {
      this.islocal = true;
    } else {
      this.islocal = false;
    }
    this.selectObj = e;
  }
  checkExist(unionId: any) {
    const qrinfo = window.localStorage.getItem('qrinfo');
    if (!qrinfo) {
      checkIsFirst(unionId).then((res: any) => {
        if (res.code === 200) {
          this.qrinfo.DDH = res.data.qr_ddh;
          this.qrinfo.HXM = res.data.qr_hxm;
          this.qrinfo.JZSJ = res.data.qr_jzsj;
          this.qrinfo.KSSJ = res.data.qr_kssj;
          this.qrinfo.TB = res.data.qr_tb;
          this.qrinfo.ZYSX = res.data.qr_zysx;
          this.qrinfo.unionid = res.data.userId;
          this.qrinfo.dreamsch = res.data.dreamsch;
          this.qrinfo.phone = res.data.phone;
          this.qrinfo.qqnum = res.data.qqnum;
          this.qrinfo.name = res.data.name;
          this.qrinfo.qqnum = res.data.qqnum;
          this.qrinfo.phone = res.data.phone;
          if (!res.data.realcity || !res.data.realname) {
            window.localStorage.removeItem('qrinfo');
            this.phone = res.data.phone;
            this.name = res.data.name;
            this.dreamsch = res.data.dreamsch;
            this.qqnum = res.data.qqnum;
            this.isnew = true;
          } else {
            this.qrinfo.realcity = res.data.realcity;
            this.qrinfo.realname = res.data.realname;
            this.isnew = false;
            window.localStorage.setItem('qrinfo', qs.stringify(this.qrinfo));
            this.$router.push('isactived');
          }
        } else {
        }
      });
    } else {
      const qrdata = qs.parse(qrinfo);
      if (unionId !== qrdata.unionid) {
        window.localStorage.removeItem('qrinfo');
        window.location.reload();
      }
      if (!qrdata.realcity || !qrdata.realname) {
        window.localStorage.removeItem('qrinfo');
        this.phone = qrdata.phone;
        this.name = qrdata.name;
        this.dreamsch = qrdata.dreamsch;
        this.qqnum = qrdata.qqnum;
        this.isnew = true;
      } else {
        this.$router.push('isactived');
      }
    }
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  submitinfo() {
    if (!this.isclick) {
      Toast('请勿重复提交！');
      return false;
    }
    this.isclick = false;
    setTimeout(() => {
      this.isclick = true;
    }, 2000);
    if (!this.name) {
      Toast('请填写姓名！');
      return false;
    } else if (!/^1[345789][0-9]{9}$/.test(this.phone)) {
      Toast('电话号码格式错误！');
      return false;
    } else if (!this.dreamsch) {
      Toast('请填写梦想高校！');
      return false;
    } else if (!this.qqnum) {
      Toast('请填写QQ号码！');
      return false;
    } else if (!this.selectObj) {
      Toast('请选择高校地区');
      return false;
    } else if (!this.inputStr) {
      Toast('请输入梦想高校名称');
      return false;
    } else {
      this.submitPerson();
    }
  }
  async submitPerson() {
    this.unionid = window.localStorage.getItem('unionid');
    if (!isWeiXin()) {
      this.errinfo = '请在微信中打开，参与活动';
      this.nowx = true;
      return false;
    } else if (!this.unionid && isWeiXin()) {
      this.WechatLogin();
      return false;
    }
    const data = {
      unionid: this.unionid,
      name: this.name,
      phone: this.phone,
      dreamsch: this.dreamsch,
      qqnum: this.qqnum,
      realcity: this.selectObj,
      realname: this.inputStr,
    };
    saveinfo(data).then((res: any) => {
      console.log('res:::', res);
      if (res.code === 200) {
        this.qrinfo.DDH = res.data.qr_ddh;
        this.qrinfo.HXM = res.data.qr_hxm;
        this.qrinfo.JZSJ = res.data.qr_jzsj;
        this.qrinfo.KSSJ = res.data.qr_kssj;
        this.qrinfo.TB = res.data.qr_tb;
        this.qrinfo.ZYSX = res.data.qr_zysx;
        this.qrinfo.unionid = res.data.userId;
        this.qrinfo.dreamsch = res.data.dreamsch;
        this.qrinfo.name = res.data.name;
        this.qrinfo.qqnum = res.data.qqnum;
        this.qrinfo.phone = res.data.phone;
        this.qrinfo.realcity = res.data.realcity;
        this.qrinfo.realname = res.data.realname;
        window.localStorage.setItem('qrinfo', qs.stringify(this.qrinfo));
        this.$router.push('isactived');
      } else {
        Toast(res.msg);
      }
    });
  }
}
